<template>
    <van-popup v-model:show="show" position="right" :style="{
        minWidth: '100%',
        minHeight: '100%',
        background: 'green',
        color: '#fff',
        overflow: 'hidden',
    }">
        <div class="popupContainer">
            <van-row class="header">
                <van-col span="3" class="backIcon">
                    <img src="@/assets/common/backIcon.png" alt="" @click="close">
                </van-col>
                <van-col class="header_item_logo" span="8">
                    <img :src="dataSet?.mainHeader.url" v-if="dataSet?.mainHeader.display" alt="">
                </van-col>
                <van-col v-if="userStore.loginAccount" span="13" class="header_button_item" align="center">
                    <div v-if="dataSet?.depositButon.display" @click="goToDeposit" class="coin_btn"
                        :style="{ backgroundImage: dataSet?.depositButon.colorCode }">
                        <div>{{ dataSet?.balance }}</div>
                        <span>
                            <img src="@/assets/common/plus.png" alt="">
                        </span>
                    </div>
                    <div v-if="dataSet?.profileButtonData.display" class="avatar_btn">
                        <img src="@/assets/common/head_icon.jpg" alt="" @click="goToProfile">
                        <span class="more_img">
                            <img :src="dataSet?.profileButtonData.url" alt="">
                        </span>
                    </div>
                </van-col>
            </van-row>
            <van-row class="sec_header">
                <van-col span="2" style="display: flex;align-items: center;">
                    <div class="vertical-line"></div>
                </van-col>
                <van-col class="sec_header_item_logo" span="12">
                    <img :src="activeItemIcon" alt="" />
                </van-col>
                <van-col span="6">

                </van-col>
                <van-col span="4">
                    <div ref="triggerRef">
                        <van-popover id="groupListPop" v-model:show="showPopover" :actions="[]" placement="bottom-end">
                            <template #reference>
                                <img :src="dataSet?.profileButtonData.url" alt="" />
                            </template>
                            <div ref="popoverRef">
                                <div v-for="item in dataSet?.groupList" :key="item.id" class="game_menu_item"
                                    :class="dataSet?.activeItem === item.id ? 'active_group' : ''"
                                    @click="selectGroup(item)">
                                    <van-row align="center">
                                        <van-col :span="24" class="menu_icon_column">
                                            <img :src="item.icon" alt="" />
                                        </van-col>
                                    </van-row>
                                </div>
                            </div>
                        </van-popover>
                    </div>
                </van-col>
            </van-row>
            <van-row class="game_container">
                <van-col span="24" class="right_container">
                    <van-row>
                        <van-col span="8" class="game_item" v-for="(item, index) in dataSet?.gameList" :key="index">
                            <GameCard :gameImage="item.customIcon"
                                @clickGameCard="goToPlayGame(item.gameId, item.gameMakerId)" :gameTypeId="item.id"
                                :gameIsFavorite="item.isFavorite" />
                        </van-col>
                    </van-row>
                    <div v-if="!dataSet?.loading && dataSet?.showLoadMore" class="load_more_btn" @click="loadMoreGame">
                        {{ $t('common.loadMore') }}
                        <img src="@/assets/common/loadMore.png" alt="">
                    </div>
                    <div v-if="dataSet?.loading" class="loading_btn" @click="loadMoreGame">
                        <van-loading size="20" />
                        {{ $t('common.loading') }}
                    </div>
                </van-col>
            </van-row>
        </div>
    </van-popup>
</template>

<script setup lang="ts">
import { defineProps, ref, defineExpose, computed, defineEmits, onMounted, onBeforeUnmount, PropType } from 'vue'
import GameCard from './components/gameCard.vue'
import { useUserStore } from '@/stores/user'
import { GameData } from '@/view/game/supportScript';
const userStore = useUserStore()
const popoverRef = ref<HTMLElement | null>(null)
const triggerRef = ref<HTMLElement | null>(null)
const props = defineProps({
    dataSet: {
        type: Object as PropType<GameData>,
        required: true
    }
})

const show = computed({
    get: () => props.dataSet.show,
    set: (val) => emits('update:show', val)
})

const showPopover = computed({
    get: () => props.dataSet.showPopover,
    set: (val) => emits('update:showPopover', val)
})
const emits = defineEmits(['update:show', 'update:showPopover', 'open', 'close', 'goToProfile', 'selectGroup', 'loadMoreGame', 'goToDeposit', 'goToPlayGame', 'openRegisterPopup'])

const activeItemIcon = computed(() => {
    const item = props.dataSet.groupList.find((i: any) => i.id == props.dataSet.activeItem);
    return item?.icon;
});

const open = (id: number | string) => {
    emits('open', id)
}
const close = () => {
    emits('close')
}
const goToProfile = () => {
    emits('goToProfile')
}
const selectGroup = (item: any) => {
    emits('selectGroup', item)
}
const loadMoreGame = () => {
    emits('loadMoreGame')
}
const goToDeposit = () => {
    emits('goToDeposit')
}
const handleClickOutside = (event: MouseEvent) => {
    const popoverEl = popoverRef.value
    const triggerEl = triggerRef.value
    if (
        popoverEl &&
        !popoverEl.contains(event.target as Node) &&
        triggerEl &&
        !triggerEl.contains(event.target as Node)
    ) {
        showPopover.value = false
    }
}
const goToPlayGame = (ID: any, makerID: any) => {
    let data = {
        id: ID,
        makerId: makerID
    }
    emits('goToPlayGame', data)
}

defineExpose({
    open,
})
onMounted(() => {
    document.addEventListener('click', handleClickOutside)
})

onBeforeUnmount(() => {
    document.removeEventListener('click', handleClickOutside)
})
</script>
<style scoped>
:deep(.van-popover__content) {
    height: 500px;
    width: 220px;
    overflow-y: auto;
}

#groupListPop>>>.van-popover__content {
    background: #27190d !important;
    padding: 5px 0px !important;
}

#groupListPop>>>.van-popover__arrow {
    color: #27190df5 !important;
}

#groupListPop>>>.van-popover__content::-webkit-scrollbar {
    display: none;
}

.header {
    color: #FFFFFF;
    font-size: 15px;
    text-align: center;
    font-weight: 700;
    padding: 10px 0;
    background-image: url('@/assets/main_bg.png');
    background-size: cover;
    background-repeat: repeat;
    box-shadow: rgba(0, 0, 0, 0.25) 0px 2px 4px 0px;
}

.header img {
    width: 35px;
}

.backIcon img {
    width: 15px;
    background: #ffffff17;
    padding: 10px;
    border-radius: 10px;
    opacity: 0.6;
}

.sec_header {
    /* background: #27190D; */
    color: #FFFFFF;
    font-size: 15px;
    text-align: center;
    font-weight: 700;
    padding: 10px 0;
}

.sec_header img {
    width: 35px;
}

.header_item_logo {
    display: flex;
    align-items: center;
    padding: 0;
}

.header_item_logo img {
    width: 120px;
}

.sec_header_item_logo {
    display: flex;
    align-items: center;
    padding: 0;
}

.sec_header_item_logo img {
    width: auto;
    height: 35px;
}

.head_text {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.header_button_item {
    padding: 0 18px;
    display: flex;
    align-items: center;
    justify-content: right;
}

.avatar_btn img {
    width: 25px;
    border-radius: 30px;
}

.more_img img {
    width: 12px;
    position: absolute;
    margin: 15px 0px 0px -12px;
}

.popupContainer {
    background: url('@/assets/main_bg.png');
    background-size: cover;
    background-repeat: repeat;
    width: 100%;
    height: 100vh;
    overflow: hidden;
}

.left_container {
    display: flex;
    flex-direction: column;
    padding: 5px;
    height: 100%;
    overflow-y: auto;
}

.game_menu_item {
    /* background: rgba(255, 255, 255, 0.04); */
    background: #81644833;
    overflow: hidden;
    border-radius: 13.5px;
    color: rgba(255, 255, 255, 0.85);
    border: 1px solid #5a4010;
    font-size: 14px;
    padding: 4px 16px 4px;
    margin: 0 5px 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    /* width: 30px; */
    min-height: 40px;
}

.coin_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    color: #12151A;
    /* background-image: linear-gradient(180deg, #F8D8A7 0%, #F0A853 100%); */
    font-size: 15px;
    font-weight: 700;
    border-radius: 20px;
    padding: 2px 10px;
    margin-right: 5px;
    white-space: nowrap;
    overflow: hidden;
}

.menu_text_column {
    display: flex;
    align-items: center;
    justify-content: center;
}

.coin_btn div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
}

.coin_btn img {
    width: 10px;
    padding-left: 5px;
}

.game_menu_item img {
    width: 25px;
    opacity: 0.8;
}

.game_menu_item p {
    margin: 8px 0 0;
}

.game_item {
    padding: 5px;
}

.right_container {
    padding-right: 10px;
    height: 100%;
    overflow-y: auto;
}

.active_group {
    color: rgba(0, 0, 0, 0.85);
    background-image: linear-gradient(180deg, #f0cd97 0%, #F0A853 100%);
    font-weight: 700;
}

.active_group img {
    filter: brightness(0.8);
    opacity: 1
}

.game_container {
    flex: 1;
    display: flex;
    height: 100%;
    overflow: hidden;
}

.vertical-line {
    width: 4px;
    height: 90%;
    margin: 0 auto;
    background: linear-gradient(rgb(248, 216, 167) 0%, rgb(240, 168, 83) 100%);
    border-radius: 5px;

}

.left_container,
.right_container {
    height: 100%;
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    padding-bottom: 200px;
}

.left_container::-webkit-scrollbar,
.right_container::-webkit-scrollbar {
    display: none;
}

.load_more_btn {
    font-size: 15px;
    background: rgba(255, 255, 255, 0.04);
    color: rgba(255, 255, 255, 0.65);
    border-radius: 20px;
    padding: 10px 25px;
    display: flex;
    justify-content: center;
    margin: 10px 65px;

}

.load_more_btn img {
    width: 15px;
    opacity: 0.5;
    margin-left: 10px;
}

.loading_btn {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.65);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 25px;
    margin: 5px 65px;
}

.loading_btn>>>.van-loading {
    padding: 0 10px;
}

.menu_icon_column img {
    width: auto;
    height: 35px;
}
</style>